const compare = (a, b) => {
  return a > b ? 1 : a < b ? - 1: 0;
}

const sortTableResult = (array, field, crescente) => {
  return array.sort((a, b) => crescente ? compare(a[field], b[field]) : compare(b[field], a[field]));
}

const trueFalseNull = (value) => {
  if (value === null) return true;
  if (value) return false;
  return null;
}

const getIconSort = (value) => {
  if (value === null) return 'arrow_downward';
  if (value) return 'arrow_upward';
  return 'arrow_downward';
}

export default {sortTableResult, trueFalseNull, getIconSort};